module.exports = __webpack_public_path__ + "img/loading_gif.35a90dbc.gif";